import React from "react";

const PROJECTED_DISPLAY_GRID_SECTION_IDS = new Set([
    "komonofuda",
    "brandname",
    "othername",
    "other_fukushizai"
]);

function renderEmptyBody() {
    return (
        <div style={{ minHeight: 120, border: "1px solid #d0d0d0", borderRadius: 4, backgroundColor: "#fafafa" }}>
        </div>
    );
}

export function isProjectedDisplayGridSection(section) {
    const sectionId = String(section?.id ?? "").trim();
    return PROJECTED_DISPLAY_GRID_SECTION_IDS.has(sectionId);
}

export function renderProjectedDisplayGridSectionBody({
    section,
    gridSectionPanel,
    stableGridPanel,
    hasGridColumns,
    rowStyle,
    renderContents,
    buildDemandColumns,
    buildBrandNameGridColumns,
    toStableAutoHeightPanel
}) {
    if (!hasGridColumns) {
        return renderEmptyBody();
    }

    const renderGridPanel = stableGridPanel || toStableAutoHeightPanel(gridSectionPanel, section.id);
    const querySetColumn = (colDef) => {
        let next = buildDemandColumns(colDef, renderGridPanel);
        if (section.id === "brandname") {
            next = buildBrandNameGridColumns(next);
        }
        return next;
    };

    return renderContents({
        panel: renderGridPanel,
        getRowStyle: rowStyle,
        QuerySetColumn: querySetColumn
    });
}
